"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var SortDirection;
(function (SortDirection) {
    /**
     * Sort from small to large values.
     */
    SortDirection["Asc"] = "ascending";
    /**
     * Sort from large to small values.
     */
    SortDirection["Desc"] = "descending";
})(SortDirection = exports.SortDirection || (exports.SortDirection = {}));
//# sourceMappingURL=types.js.map